export enum LocationStorageEnum {
  sicForPostalCodesKey = 'RATING_sicForPostalCodes'
};
